/*
  Figma node 5228:34060 — the peach "V" behind the top row of the card.

  Inline SVG rather than `clip-path: polygon()` + a CSS gradient: clip-path is
  the least reliable thing to push through a rasterizer (html2canvas ignores it
  outright, which would leave a solid 1840x501 peach rectangle covering the
  whole top half of the card). Inline SVG needs no asset, no network fetch and
  no CORS, and `userSpaceOnUse` + `preserveAspectRatio="none"` reproduces the
  gradient exactly at any box size.

  The gradient id is static, so render at most one BvaPdfDocument at a time.
  Deliberately not useId() — React returns ":r0:", and url(#:r0:) is not a
  valid SVG reference.
*/
export const BvaPdfWedge = () => (
  <svg
    className="bva-pdf__wedge-svg"
    width="1840"
    height="501"
    viewBox="0 0 1840 501"
    fill="none"
    preserveAspectRatio="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M0 0H1840V240.031L920 501L0 240.031V0Z" fill="url(#bva-pdf-wedge-gradient)" />
    <defs>
      <linearGradient id="bva-pdf-wedge-gradient" x1="920" y1="501" x2="920" y2="0" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FEE0D4" />
        <stop offset="1" stopColor="#FFFFFF" />
      </linearGradient>
    </defs>
  </svg>
)
